import { create } from 'zustand'

export type StepsType = 1 | 2 | 3 | 4 | 5

export interface StudioFinderStore {
  step: StepsType
  actions: {
    setStep: (step: StepsType) => void
  }
}

export function createStudioFinderStore(initialStep: StepsType = 1) {
  return create<StudioFinderStore>()((set) => ({
    step: initialStep,
    actions: {
      setStep: (step: StepsType) => set({ step }),
    },
  }))
}
